import usePendingNotification from './usePendingNotification';

export default usePendingNotification;
